<div class="px-2">
    <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields()" [model]="componentModel"></formly-form>
    </form>
</div>
